import UploadContext from './UploadContext'
import { useContext } from 'react'

const useUpload = () => useContext(UploadContext)

export default useUpload
